<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLSelectAttributes } from 'svelte/elements';
  import { cn } from '../lib/cn';
  import { controlClass } from './form';

  let {
    class: className,
    value = $bindable(),
    children,
    ...rest
  }: HTMLSelectAttributes & { children?: Snippet } = $props();
</script>

<select bind:value class={cn(controlClass, 'min-h-11', className as string | undefined)} {...rest}>
  {@render children?.()}
</select>
